export default "__VITE_ASSET__0NvEnUDb__";